import { db } from '../../firebaseConfig';
import { doc, collection, setDoc, addDoc, Timestamp, updateDoc, query, where, documentId, getDoc, getDocs } from "firebase/firestore"; 
import { getFunctions, httpsCallable } from "firebase/functions";

// Not used yet
export async function getUserDocIdByUsername(username) {

    const q = query(collection(db, "Users"), where('userNameLowerCase', "==", username.toLowerCase()));

    const querySnapshot = await getDocs(q);
    var userIdWithUsername = null;
    querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        //console.log(doc.id, " => ", doc.data());
        userIdWithUserName = doc.id;
    });
    return userIdWithUsername;
}

export async function getUserDataByUserId(userId) {
    //console.log('getUserDataByUserId userId=' + userId);
    const userRef = doc(db, "Users", userId);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
        console.log('No such document!');
        return null;
    }

    // query the Businesses collection to get the business id(s) associated with this user
    const q = query(collection(db, "Businesses"), where('userId', "array-contains", userId), where('status', 'in', [['approved']]));
    const querySnapshot = await getDocs(q);
    var businessIds = [];
    querySnapshot.forEach((doc) => {
        businessIds.push(doc.id);
    });

    const qPending = query(collection(db, "Businesses"), where('userId', "array-contains", userId), where('status', 'in', [['pendingapproval']]));
    const querySnapshotPending = await getDocs(qPending);
    var pendingBusinessIds = [];
    querySnapshotPending.forEach((doc) => {
        pendingBusinessIds.push(doc.id);
    });

    //console.log('businessIds=', businessIds);

    // adding some null checks - this feels hacky though, shouldn't be needed, means something is wrong
    return {
        username: userSnap.data().username ? userSnap.data().username : '',
        storageImageUrl: userSnap.data().storageImageUrl ? userSnap.data().storageImageUrl : '',
        role: userSnap.data().role ? userSnap.data().role : '',
        emailLowerCase: userSnap.data().emailLowerCase ? userSnap.data().emailLowerCase : '',
        favoriteBar: userSnap.data().favoriteBar ? userSnap.data().favoriteBar : '',
        favoriteBarPlaceId: userSnap.data().favoriteBarPlaceId ? userSnap.data().favoriteBarPlaceId : '',
        phone: userSnap.data().phone ? userSnap.data().phone : '',
        email: userSnap.data().email ? userSnap.data().email : '',
        isEmailConfirmed: userSnap.data().isEmailConfirmed ? userSnap.data().isEmailConfirmed : false,
        businessIds: businessIds,
        pendingBusinessIds: pendingBusinessIds,
    }
}

export async function getUserContactInfoByUserId(userId) {
    if (!userId) {
        return null;
    }

    const userRef = doc(db, "Users", userId);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
        return null;
    }

    return {
        email: userSnap.data().email ? userSnap.data().email : '',
        phone: userSnap.data().phone ? userSnap.data().phone : '',
    };
}

export async function getBarNamesByBusinessIds(businessIds) {
    if (!businessIds || businessIds.length === 0) {
        return [];
    }

    // Firestore 'in' queries only support up to 10 values, so query in chunks
    const chunkSize = 10;
    const results = [];
    for (let i = 0; i < businessIds.length; i += chunkSize) {
        const chunk = businessIds.slice(i, i + chunkSize);
        const q = query(collection(db, "Businesses"), where(documentId(), 'in', chunk));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            results.push({ id: doc.id, bar: doc.data().bar ? doc.data().bar : '' });
        });
    }

    return results;
}

export async function getBusinessDetails(businessId) {
    if (!businessId) {
        return null;
    }

    const docRef = doc(db, "Businesses", businessId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
        return { id: docSnap.id, ...docSnap.data() };
    } else {
        return null;
    }
}

export async function getUserIdByEmail(email) {
    // Query the Users collection for a document with the given email (case-insensitive)
    const q = query(collection(db, "Users"), where('emailLowerCase', "==", email.toLowerCase()));
    const querySnapshot = await getDocs(q);
    // Return the first matching document's id, or null if not found
    const doc = querySnapshot.docs[0];
    return doc ? doc.id : null;
}

export async function getUserIdByPhone(phone) {
    // Query the Users collection for a document with the given phone number (case-insensitive)
    const q = query(collection(db, "Users"), where('phone', "==", phone));
    const querySnapshot = await getDocs(q);
    // Return the first matching document's id, or null if not found
    const doc = querySnapshot.docs[0];
    return doc ? doc.id : null;
}

export async function isEmailConfirmedForAnotherUser(email, currentUserId) {
    // Query the Users collection for a document with the given email that is confirmed
    const q = query(
        collection(db, "Users"), 
        where('emailLowerCase', "==", email.toLowerCase()),
        where('isEmailConfirmed', "==", true)
    );
    const querySnapshot = await getDocs(q);
    
    // Check if any confirmed user exists with this email that isn't the current user
    for (const doc of querySnapshot.docs) {
        if (doc.id !== currentUserId) {
            return true; // Email is confirmed for another user
        }
    }
    return false; // Email is not confirmed for another user
}

export async function isPhoneConfirmedForAnotherUser(phone, currentUserId) {
    // Query the Users collection for a document with the given phone that is confirmed
    const q = query(
        collection(db, "Users"), 
        where('phone', "==", phone),
        where('isPhoneConfirmed', "==", true)
    );
    const querySnapshot = await getDocs(q);
    
    // Check if any confirmed user exists with this phone that isn't the current user
    for (const doc of querySnapshot.docs) {
        if (doc.id !== currentUserId) {
            return true; // Phone is confirmed for another user
        }
    }
    return false; // Phone is not confirmed for another user
}

export async function updateUserEmailToConfirmed(userId, email) {

    const userRef = doc(db, "Users", userId);

    await updateDoc(userRef, {
        email: email,
        isEmailConfirmed: true
    });

    console.log('updated user email to confirmed - in Users');
}

export async function sendOneTimeLoginCode(phone) {

    const functions = getFunctions();

    console.log('sendOneTimeLoginCode phone=' + phone);

    const sendVerificationCode = httpsCallable(functions, 'sendVerificationCode');
    sendVerificationCode({ phoneNumber: phone })
        .then((result) => {
            // // Read result of the Cloud Function.
            // // @type {any} 
            // const data = result.data;
            // const sanitizedMessage = data.text;
            console.log('success calling sendVerificationCode');
        })
        .catch((error) => {
            console.log('error calling sendVerificationCode', error);
            // Getting the Error details.
            // const code = error.code;
            // const message = error.message;
            // const details = error.details;
            // ...
        });
}

export async function sendOneTimeLoginCodeByEmail(email, code) {

    const functions = getFunctions();

    console.log('sendOneTimeLoginCodeByEmail email =' + email);

    const sendVerificationCodeByEmail = httpsCallable(functions, 'sendVerificationCodeByEmail');
    sendVerificationCodeByEmail({ email: email, code: code })
        .then((result) => {
            // // Read result of the Cloud Function.
            // // @type {any} 
            // const data = result.data;
            // const sanitizedMessage = data.text;
            console.log('success calling sendVerificationCodeByEmail');
        })
        .catch((error) => {
            console.log('error calling sendVerificationCodeByEmail', error);
            // Getting the Error details.
            // const code = error.code;
            // const message = error.message;
            // const details = error.details;
            // ...
        });
}

export async function verifyCodeByTwilio(code, phoneNumber) {

    const functions = getFunctions();

    console.log('verifyCodeByTwilio code=' + code + ' phoneNumber=' + phoneNumber);

    const verifyCode = httpsCallable(functions, 'verifyCode');
    
    try {
        const result = await verifyCode({ code: code, phoneNumber: phoneNumber });
        
        // Read result of the Cloud Function
        const data = result.data;
        console.log('success calling verifyCode:', data);
        
        return data; // Return the result so calling code can handle success/failure
        
    } catch (error) {
        console.log('error calling verifyCode', error);
        // Return error information
        return { 
            success: false, 
            error: error.message || 'Unknown error occurred' 
        };
    }
}

/* not used
export async function sendOneTimeLoginCodeByEmail2(email) {

    const functions = getFunctions();

    console.log('sendOneTimeLoginCodeByEmail2 email =' + email);

    const sendVerificationCodeByEmail = httpsCallable(functions, 'sendVerificationCodeByEmail');
    sendVerificationCodeByEmail({ email: email })
        .then((result) => {
            // // Read result of the Cloud Function.
            // // @type {any} 
            // const data = result.data;
            // const sanitizedMessage = data.text;
            console.log('success calling sendVerificationCodeByEmail from sendOneTimeLoginCodeByEmail2');
        })
        .catch((error) => {
            console.log('error calling sendVerificationCodeByEmail from sendOneTimeLoginCodeByEmail2', error);
            // Getting the Error details.
            // const code = error.code;
            // const message = error.message;
            // const details = error.details;
            // ...
        });
}
*/